// @ts-nocheck
const URL = process.env.PUBLIC_URL + '/assets/scenes/loots_and_pillars.gltf'
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    jackolantern_big001: THREE.Mesh;
    Sphere003: THREE.Mesh;
    Sphere003_1: THREE.Mesh;
    Sphere003_2: THREE.Mesh;
    Sphere003_3: THREE.Mesh;
    Cylinder001: THREE.Mesh;
    Cylinder001_1: THREE.Mesh;
    Cylinder001_2: THREE.Mesh;
    Cylinder001_3: THREE.Mesh;
    Cylinder001_4: THREE.Mesh;
    Cylinder001_5: THREE.Mesh;
    Cube104: THREE.Mesh;
    Cube104_1: THREE.Mesh;
    Cube104_2: THREE.Mesh;
    Cube104_3: THREE.Mesh;
    Cube104_4: THREE.Mesh;
    Cube104_5: THREE.Mesh;
    Cube002: THREE.Mesh;
    Cube002_1: THREE.Mesh;
    Cube103: THREE.Mesh;
    Cube103_1: THREE.Mesh;
  };
  materials: {
    ["Orange.010"]: THREE.MeshStandardMaterial;
    ["Black.015"]: THREE.MeshStandardMaterial;
    ["GreenLight.002"]: THREE.MeshStandardMaterial;
    ["Green.002"]: THREE.MeshStandardMaterial;
    ["BrownDark.006"]: THREE.MeshStandardMaterial;
    ["White.009"]: THREE.MeshStandardMaterial;
    ["Purple.007"]: THREE.MeshStandardMaterial;
    ["Blue.003"]: THREE.MeshStandardMaterial;
    ["Yellow.009"]: THREE.MeshStandardMaterial;
    ["Beige.004"]: THREE.MeshStandardMaterial;
    ["Orange.012"]: THREE.MeshStandardMaterial;
    ["Beige.005"]: THREE.MeshStandardMaterial;
    ["Blue.004"]: THREE.MeshStandardMaterial;
    ["White.010"]: THREE.MeshStandardMaterial;
    ["Purple.008"]: THREE.MeshStandardMaterial;
    ["Yellow.010"]: THREE.MeshStandardMaterial;
    ["Orange.013"]: THREE.MeshStandardMaterial;
    ["Stone.009"]: THREE.MeshStandardMaterial;
    ["StoneDark.001"]: THREE.MeshStandardMaterial;
  };
};

export function Model(props: JSX.IntrinsicElements["group"]) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult;
  return (
    <group {...props} dispose={null}>
      <mesh
        name="jackolantern_big001"
        castShadow
        receiveShadow
        geometry={nodes.jackolantern_big001.geometry}
        material={materials["Orange.010"]}
        position={[-8.8, 2.27, 6.02]}
        rotation={[-Math.PI, 1.23, -Math.PI]}
        userData={{ name: "jackolantern_big.001" }}
      />
      <group
        name="cauldron001"
        position={[8.64, 2, -7.03]}
        userData={{ name: "cauldron.001" }}
      >
        <mesh
          name="Sphere003"
          castShadow
          receiveShadow
          geometry={nodes.Sphere003.geometry}
          material={materials["Black.015"]}
        />
        <mesh
          name="Sphere003_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere003_1.geometry}
          material={materials["GreenLight.002"]}
        />
        <mesh
          name="Sphere003_2"
          castShadow
          receiveShadow
          geometry={nodes.Sphere003_2.geometry}
          material={materials["Green.002"]}
        />
        <mesh
          name="Sphere003_3"
          castShadow
          receiveShadow
          geometry={nodes.Sphere003_3.geometry}
          material={materials["BrownDark.006"]}
        />
      </group>
      <group
        name="candyBucket001"
        position={[6.5, 0.4, 3.52]}
        rotation={[0, 0.93, 0]}
        userData={{ name: "candyBucket.001" }}
      >
        <mesh
          name="Cylinder001"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001.geometry}
          material={materials["White.009"]}
        />
        <mesh
          name="Cylinder001_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_1.geometry}
          material={materials["Purple.007"]}
        />
        <mesh
          name="Cylinder001_2"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_2.geometry}
          material={materials["Blue.003"]}
        />
        <mesh
          name="Cylinder001_3"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_3.geometry}
          material={materials["Yellow.009"]}
        />
        <mesh
          name="Cylinder001_4"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_4.geometry}
          material={materials["Beige.004"]}
        />
        <mesh
          name="Cylinder001_5"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_5.geometry}
          material={materials["Orange.012"]}
        />
      </group>
      <group
        name="candyBag001"
        position={[-6.48, 0.54, -4.49]}
        rotation={[0, 0.7, 0]}
        userData={{ name: "candyBag.001" }}
      >
        <mesh
          name="Cube104"
          castShadow
          receiveShadow
          geometry={nodes.Cube104.geometry}
          material={materials["Beige.005"]}
        />
        <mesh
          name="Cube104_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube104_1.geometry}
          material={materials["Blue.004"]}
        />
        <mesh
          name="Cube104_2"
          castShadow
          receiveShadow
          geometry={nodes.Cube104_2.geometry}
          material={materials["White.010"]}
        />
        <mesh
          name="Cube104_3"
          castShadow
          receiveShadow
          geometry={nodes.Cube104_3.geometry}
          material={materials["Purple.008"]}
        />
        <mesh
          name="Cube104_4"
          castShadow
          receiveShadow
          geometry={nodes.Cube104_4.geometry}
          material={materials["Yellow.010"]}
        />
        <mesh
          name="Cube104_5"
          castShadow
          receiveShadow
          geometry={nodes.Cube104_5.geometry}
          material={materials["Orange.013"]}
        />
      </group>
      <group
        name="pillar_broken001"
        position={[-8.8, -1, 6]}
        userData={{ name: "pillar_broken.001" }}
      >
        <mesh
          name="Cube002"
          castShadow
          receiveShadow
          geometry={nodes.Cube002.geometry}
          material={materials["Stone.009"]}
        />
        <mesh
          name="Cube002_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube002_1.geometry}
          material={materials["StoneDark.001"]}
        />
      </group>
      <group
        name="pillar_broken002"
        position={[8.68, -1, -7]}
        rotation={[-Math.PI, 0.09, -Math.PI]}
        userData={{ name: "pillar_broken.002" }}
      >
        <mesh
          name="Cube103"
          castShadow
          receiveShadow
          geometry={nodes.Cube103.geometry}
          material={materials["Stone.009"]}
        />
        <mesh
          name="Cube103_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube103_1.geometry}
          material={materials["StoneDark.001"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(URL);
